export default "__VITE_ASSET__4d2abab2__"